import { sendGoogleGoal } from 'www/utils'

document.addEventListener('click', (event: Event) => {
  try {
    const target = event.target as HTMLElement
    const googleGoalNode = target.closest('[data-google-goal]')

    if (googleGoalNode) {
      sendGoogleGoal(googleGoalNode.getAttribute('data-google-goal') as string)
    }
  } catch { /* Empty */ }
})
